import store from '../index';
import { PROGRESS_BAR_SHOW_START_LIMIT } from '../../constants';

const state = {
    isVisible: false,
    title: '',
    progress: 0, // per cents in [0, 100]
    startTime: 0,
    timeElapsed: null, // in seconds
    timeSpent: null, // in seconds
    timeLeft: null, // in seconds
    isCanceled: false,
};

const mutations = {
    PROGRESS_BAR_START: (state, title) => {
        state.isVisible = false;
        state.title = title;
        state.progress = 0;
        state.startTime = Date.now() * 0.001;
        state.timeElapsed = null;
        state.timeSpent = null;
        state.timeLeft = null;
    },

    PROGRESS_BAR_UPDATE: (state, progress) => {
        // New progress is integer (rounded up).
        // New progress should be >= old progress (no change otherwise).
        // New progress > 100 is treated as 100.
        state.progress = Math.min(Math.max(state.progress, Math.ceil(progress)), 100);

        // Update time estimations
        let currentTime = Date.now() * 0.001;
        let timeSpent = currentTime - state.startTime;
        if (state.progress > 0 && timeSpent > 0) {
            state.timeElapsed = (100.0 * timeSpent) / state.progress;
            state.timeSpent = timeSpent;
            state.timeLeft = state.timeElapsed - timeSpent;
        }
        state.isVisible = state.isVisible || state.timeLeft > PROGRESS_BAR_SHOW_START_LIMIT;
    },

    PROGRESS_BAR_HIDE: state => {
        state.isVisible = false;
        state.isCanceled = false;
    },
};

const actions = {
    start({ commit }, title) {
        commit('PROGRESS_BAR_START', title);
        store.commit('SHOW_LOADING', true);
    },

    update({ commit }, progress) {
        commit('PROGRESS_BAR_UPDATE', progress);
        if (store.state.progressBar.isVisible) {
            store.commit('SHOW_LOADING', false);
        }
    },

    hide({ commit }) {
        commit('PROGRESS_BAR_HIDE');
        store.commit('SHOW_LOADING', false);
    },

    beforeDestroy({ commit }) {
        commit('PROGRESS_BAR_HIDE');
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
